<template>
    <div class="flex-1 flex flex-col sm:items-center justify-between border-r border-gray-400 cursor-pointer"
        :class="selected ? selected_bg : ''"
        @click="filter"
    >
        <div class="flex flex-row mx-4 xs:mx-6 sm:mx-0 pb-2 pt-4 sm:flex-col items-center">
            <div class="flex flex-shrink-0 w-6 h-6 md:w-7 md:h-7 mb-2 border border-gray-600 rounded-full items-center justify-center bg-white">
                <i class="fa text-md md:text-lg" :class="[icon, text_color]" aria-hidden="true"></i>
            </div>

            <div class="flex items-center mt-0 sm:mt-1 md:mt-0 sm:mb-2 pr-2">
                <h2 class="text-3xl md:text-4xl font-semibold mx-4" :class="text_color">{{ tally }}</h2>

                <p class="text-sm text-gray-600 leading-4">
                    {{ $t(status_text) }}
                </p>
            </div>
        </div>

        <div class="flex w-full border-b-2" :class="border_color"></div>
    </div>
</template>

<script>
export default {
    props: {
        color: {},
        selected: {},
        selected_bg: {},
        text_color: {},
        border_color: {},
        tally: {},
    },

    computed: {
        status_text() {
            switch (this.color) {
                case 'green':
                    return 'on track, looking good';
                case 'yellow':
                    return 'in danger of becoming late';
                case 'red':
                    return 'late, please update immediately';
            }
        },
        icon() {
            switch (this.color) {
                case 'green':
                    return 'fa-check-circle';
                case 'yellow':
                    return 'fa-exclamation-circle';
                case 'red':
                    return 'fa-exclamation-circle';
            }
        },
    },

    methods: {
        filter() {
            this.$emit('filter', this.color);
        },
    },
}
</script>
